module.exports = __webpack_public_path__ + "static/media/logo_sacombank.17dca14b.svg";